import { render } from "./PropertyGrid.vue?vue&type=template&id=1ee8d98f"
import script from "./PropertyGrid.vue?vue&type=script&lang=js"
export * from "./PropertyGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__